import { useState, useEffect } from 'react';
import { X, Gift } from 'lucide-react';
import { useGoogleAnalytics } from '@/hooks/useGoogleAnalytics';

const STORAGE_KEY = 'promo-banner-dismissed';
const CALENDLY_URL = "https://calendly.com/deborah-cerli-elyx-finance/easy-taxes";

export const PromoBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const { trackCTA } = useGoogleAnalytics();

  useEffect(() => {
    // Check if banner was previously dismissed
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (!dismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      localStorage.setItem(STORAGE_KEY, 'true');
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <div 
      className={`relative w-full bg-gradient-to-r from-green-primary via-green-secondary to-green-primary text-white overflow-hidden transition-all duration-300 ${
        isClosing ? 'h-0 opacity-0' : 'h-10 md:h-11 opacity-100'
      }`}
      role="banner"
      aria-label="Offre promotionnelle"
    >
      {/* Shimmer effect overlay */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.15) 50%, transparent 100%)',
          animation: 'shimmer 3s ease-in-out infinite',
        }}
      />
      
      <div className="container-custom px-4 h-full flex items-center justify-center relative">
        <div className="flex items-center gap-2 text-sm md:text-base font-medium">
          <Gift className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
          <span className="text-center">
            <span className="font-semibold">Simulation & entretien offert</span>
            <span className="hidden sm:inline"> - Estimez vos économies sans engagement</span>
          </span>
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackCTA('cta_click_calendly', 'promo_banner', 'banner')}
            className="ml-2 bg-white/20 hover:bg-white/30 text-white text-xs font-semibold px-3 py-1 rounded-full transition-all duration-200 whitespace-nowrap"
          >
            En profiter
          </a>
        </div>
        
        <button
          onClick={handleClose}
          className="absolute right-4 p-1.5 rounded-full hover:bg-white/20 transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50"
          aria-label="Fermer le bandeau promotionnel"
        >
          <X className="h-4 w-4" aria-hidden="true" />
        </button>
      </div>

      {/* CSS animation for shimmer */}
      <style>{`
        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </div>
  );
};

export default PromoBanner;
